import CanvasHandler from "./CanvasHandler";
import { Seat, PolygonZone } from "../canvas/detail";
import { FabricEvent } from "../types/FabricCustomType";
import { IObjectDetail } from "../types/HandlerObjectType";
import { isTouchInteraction } from "../utils/InteractionUtil";
import BaseObjectHandler from "./BaseObjectHandler";

class DetailHandler extends BaseObjectHandler<IObjectDetail> {
  constructor(canvasHandler: CanvasHandler) {
    super(canvasHandler);
    this.objectTypes = {
      seat: new Seat(canvasHandler),
      polygonZone: new PolygonZone(canvasHandler)
    };
  }

  public handleClickObject(event: FabricEvent<MouseEvent | TouchEvent>) {
    const isTouch = isTouchInteraction(event);
    if (event.target) {
      const { target: { superType } } = event;
      switch (superType) {
        case "row":
          const seat = event.subTargets?.find((t: any) => t?.superType === "seat");
          if (seat) {
            this.setType("seat");
            if (isTouch) {
              this.object.activateObjectHover(event, seat);
            }
          }

          break;
        default:
          if (isTouch) this.deactivateObjectHover();
          break;
      }
    } else {
      if (isTouch) this.deactivateObjectHover();
    }
  }
}

export default DetailHandler;
